"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paletteConditionOperators = exports.conditions = void 0;
exports.resolveConditions = resolveConditions;
exports.resolveConditionsForFilter = resolveConditionsForFilter;
exports.testConditions = testConditions;
var _bignumber = _interopRequireDefault(require("bignumber.js"));
var _util = require("../util");
var _variable = require("./variable");
var _VarsValueTypeHandler = require("./type/VarsValueTypeHandler");
var _types = require("./types");
const paletteConditionOperators = exports.paletteConditionOperators = ["truthy", "not truthy", "==", "!=", ">", ">=", "<", "<=", "contains", "!contains"];
function resolveConditions(conditions, resolver) {
  if (!conditions) {
    return null;
  }
  return conditions.map(it => {
    return {
      left: resolver.resolve(it.left),
      right: it.right ? resolver.resolve(it.right) : null,
      op: it.op,
      logic: it.logic
    };
  });
}

/**
 * This function is the same as resolveConditions, except it skips the left value if it refers to "item",
 * and instead leaves a placeholder so that it can be filled in by the filter.
 */
function resolveConditionsForFilter(conditions, resolver) {
  if (!conditions) {
    return null;
  }
  return conditions.map(it => {
    let left;
    if ((0, _util.isVariableReference)(it.left) && "name" in it.left.param && (it.left.param.name === "item" || /^item[^\w]/.test(it.left.param.name))) {
      left = (0, _VarsValueTypeHandler.toMetaValue)(null, "reference", {
        reference: it.left.param.name
      });
    } else {
      left = resolver.resolve(it.left);
    }
    return {
      left,
      right: it.right ? resolver.resolve(it.right) : null,
      op: it.op,
      logic: it.logic
    };
  });
}
function testConditions(resolved, item) {
  let previous = null;
  if (resolved.length === 0) {
    return true;
  }
  for (let it of resolved) {
    let {
      left,
      right
    } = it;
    if (_types.vals.isMeta(left) && _types.vals.metaType(left) === "reference") {
      let path = (0, _variable.parseReferencePath)(_types.vals.meta(left, "reference"));
      left = {
        type: "value",
        value: item
      };
      if (path.path) {
        left.value = (0, _variable.readReferencePath)(left.value, path.path);
      }
    }
    let result;
    const op = it.op;
    if (op === "truthy" || op === "not truthy" || !right) {
      result = _types.vals.truthy(left);
      if (op === "!=" || op === "not truthy") {
        result = !result;
      }
    } else {
      result = test(op || "==", left, right);
    }
    let logic = it.logic || "and";
    if (previous !== null) {
      switch (logic) {
        case "and":
          previous = previous && result;
          break;
        case "or":
          previous = previous || result;
          break;
        case "xor":
          previous = (previous || result) && !(previous && result);
          break;
      }
    } else {
      previous = result;
    }
  }
  return previous;
}
function eq(left, right) {
  let lh = _types.vals.handler(left);
  let rh = _types.vals.handler(right);
  if (lh.equals) {
    return lh.equals(left, right, rh);
  }
  if (rh.equals) {
    return rh.equals(right, left, lh);
  }
  if (lh.compareWith) {
    return lh.compareWith(left, right, rh) === 0;
  }
  if (rh.compareWith) {
    return rh.compareWith(right, left, lh) === 0;
  }
  if (lh.stringValue && rh.stringValue) {
    var _lh$stringValue, _rh$stringValue;
    return ((_lh$stringValue = lh.stringValue(left)) === null || _lh$stringValue === void 0 ? void 0 : _lh$stringValue.toLowerCase()) === ((_rh$stringValue = rh.stringValue(right)) === null || _rh$stringValue === void 0 ? void 0 : _rh$stringValue.toLowerCase());
  }
  return lh.value(left) === rh.value(right);
}

/**
 * Turn left and right into an array and a value for comparison. At least one of them
 * has to be a string or number, but it doesn't matter which one. Returns nothing if
 * neither is an array.
 */
function arrayAndValue(left, right) {
  let array;
  let value;
  if (Array.isArray(left.value) && left.value.length > 0) {
    array = left.value.map(it => typeof it === "string" || typeof it === "number" ? new _bignumber.default(it) : null).filter(it => !!it);
    value = new _bignumber.default(right.value);
  } else if (Array.isArray(right.value) && right.value.length > 0) {
    array = right.value.map(it => typeof it === "string" || typeof it === "number" ? new _bignumber.default(it) : null).filter(it => !!it);
    value = new _bignumber.default(left.value);
  } else {
    return {};
  }
  return {
    array,
    value
  };
}
function gt(left, right) {
  let lh = _types.vals.handler(left);
  let rh = _types.vals.handler(right);
  if (lh.numeric && rh.numeric) {
    let ln = lh.numeric(left);
    let rn = rh.numeric(right);
    if (!Array.isArray(ln) && !Array.isArray(rn)) {
      return ln.gt(rn);
    } else if (Array.isArray(ln)) {
      let val = rn;
      return !!ln.find(it => it.gt(val));
    } else if (Array.isArray(rn)) {
      let val = ln;
      return !!rn.find(it => it.lt(val));
    }
  }
  return false;
}
function lt(left, right) {
  let lh = _types.vals.handler(left);
  let rh = _types.vals.handler(right);
  if (lh.numeric && rh.numeric) {
    let ln = lh.numeric(left);
    let rn = rh.numeric(right);
    if (!Array.isArray(ln) && !Array.isArray(rn)) {
      return ln.lt(rn);
    } else if (Array.isArray(ln)) {
      let val = rn;
      return !!ln.find(it => it.lt(val));
    } else if (Array.isArray(rn)) {
      let val = ln;
      return !!rn.find(it => it.gt(val));
    }
  }
  return false;
}
function contains(left, right) {
  var _lh$stringValue2;
  let lh = _types.vals.handler(left);
  let rh = _types.vals.handler(right);
  let lv = lh.value(left);
  if (Array.isArray(lv)) {
    if (rh.equals) {
      for (let it of lv) {
        if (rh.equals(right, {
          type: "value",
          value: it
        }, lh)) {
          return true;
        }
      }
      return false;
    }
    let rv = rh.value(right);
    if (Array.isArray(rv)) {
      for (let it of rv) {
        if (!lv.includes(it)) {
          return false;
        }
      }
      return true;
    }
    return lv.includes(rv);
  }
  let rv = rh.value(right);
  if (Array.isArray(rv)) {
    if (typeof lv === "string") {
      for (let it of right.value) {
        if (!lv.includes(it.toString())) {
          return false;
        }
      }
      return true;
    }
    return false;
  }
  return (_lh$stringValue2 = lh.stringValue(left)) === null || _lh$stringValue2 === void 0 ? void 0 : _lh$stringValue2.includes(rh.stringValue(right));
}
function test(op, left, right) {
  switch (op) {
    case "!=":
      return !eq(left, right);
    case ">":
      return gt(left, right);
    case ">=":
      return eq(left, right) || gt(left, right);
    case "<":
      return lt(left, right);
    case "<=":
      return eq(left, right) || lt(left, right);
    case "contains":
      return contains(left, right);
    case "!contains":
      return !contains(left, right);
    default:
      return eq(left, right);
  }
}
const conditions = exports.conditions = {
  eq,
  gt,
  lt,
  contains,
  test
};
//# sourceMappingURL=conditions.js.map